import { $t } from '@teachino/shared-i18n';
import { isUrl } from '@teachino/shared-util';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ValidatorRule = (value: any) => string | true;

const validateRequired: ValidatorRule = (
  value: string | number | undefined,
) => {
  const errorMessage = $t('generic_form_error_required');
  if (value === undefined) {
    return errorMessage;
  }

  if (typeof value === 'string' && value.length === 0) {
    return errorMessage;
  }

  return true;
};

const validateUrl: ValidatorRule = (value: string) => {
  const errorMessage = $t('generic_error_url_invalid');

  if (!isUrl(value)) {
    return errorMessage;
  }

  return true;
};

export { validateRequired, validateUrl };
